export default __webpack_public_path__ + "static/media/Python.e3f347b9.png";